<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="$device.mobile ? 'left' : 'top'"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :sm="6">
            <el-form-item :label="$t('아이디')">
              <el-input v-model="searchForm.accountId" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item :label="$t('사용자명')">
              <el-input v-model="searchForm.accountNm" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item :label="$t('사용 가능 여부')">
              <combo
                :data="mainVue.code.useYn"
                :label="$t('전체')"
                :model="searchForm.useYn"
                @change="searchForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item :label="$t('만료 여부')">
              <combo
                :data="mainVue.code.nonExpired"
                :label="$t('전체')"
                :model="searchForm.nonExpired"
                @change="searchForm.nonExpired = $event"></combo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼 -->
    <div class="buttons" ref="buttons">
      <el-button v-if="checkAuthActionAccess('AppUserSearch')" :size="size" @click="search" icon="el-icon-search">{{
        $t('검색')
      }}</el-button>
      <el-button
        v-if="checkAuthActionAccess('AppUserUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('AppUserDel')"
        :size="size"
        @click="del"
        icon="el-icon-remove-outline"
        :disabled="btn.delDisabled"
        >{{ $t('삭제') }}</el-button
      >
    </div>

    <!-- 리스트 -->
    <el-table
      :height="tableHeight"
      ref="table"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')"
      @row-click="handleRowClick"
      @select="handleRowChecked"
      @select-all="handleRowChecked">
      <el-table-column
        :label="tableData.length.toString()"
        type="index"
        width="55"
        align="center"
        sortable
        fixed
        label-class-name="data_cnt"></el-table-column>
      <el-table-column type="selection" width="45" align="center" :fixed="!$device.mobile"></el-table-column>
      <el-table-column
        :label="$t('아이디')"
        prop="accountId"
        min-width="100"
        align="center"
        fixed
        sortable
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('매장')"
        prop="store.storeNm"
        min-width="150"
        sortable
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('사용자명')"
        prop="accountNm"
        min-width="100"
        sortable
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('닉네임')"
        prop="nickName"
        min-width="100"
        sortable
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('핸드폰 번호')"
        prop="tel"
        :formatter="util.telCell"
        min-width="130"
        align="center"></el-table-column>
      <el-table-column :label="$t('이메일')" prop="email" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('로그인 시간')"
        prop="lastLoginDtm"
        min-width="100"
        align="center"
        sortable
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('사용 가능 여부')"
        prop="useYn"
        min-width="110"
        align="center"
        :formatter="mainVue.formatterCode"></el-table-column>
      <el-table-column
        :label="$t('만료 여부')"
        prop="nonExpired"
        min-width="100"
        align="center"
        :formatter="mainVue.formatterCode"></el-table-column>
    </el-table>

    <!-- 입력 팝업 -->
    <el-dialog :title="inputForm.title" :visible.sync="dialogFormVisible" fullscreen>
      <el-form
        :model="inputForm"
        :label-width="$device.mobile ? `` : `120px`"
        :label-position="$device.mobile ? 'top' : 'left'"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row :gutter="50">
          <el-col :md="12">
            <el-form-item :label="$t('아이디')" :error="formError.accountId" required>
              <el-input
                v-model="inputForm.accountId"
                maxlength="50"
                clearable
                v-if="'I' === inputForm.statu"
                show-word-limit></el-input>
              <span v-else class="show_cd">{{ inputForm.accountId }}</span>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('가입 매장')">
              <span class="show_cd">{{ null != inputForm.store ? inputForm.store.storeNm : '' }}</span>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('사용자명')" :error="formError.accountNm" required>
              <el-input v-model="inputForm.accountNm" maxlength="50" clearable show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('닉네임')">
              <el-input v-model="inputForm.nickName" maxlength="50" clearable show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <!-- 「비밀번호를 안 바꾼다」는 **빈칸**이다 — 서버가 준 해시를 되돌려 보내지 않는다(보안 원장 ⑥).
               판정과 문구는 `utils/accountPassword` 한 곳이고, 생성에서만 필수다 -->
          <el-col :md="12">
            <el-form-item :label="$t('비밀번호')" :error="formError.accountPw" :required="passwordRequired">
              <el-input v-model="inputForm.accountPw" maxlength="20" type="password" clearable></el-input>
              <div v-if="!passwordRequired" class="account-password-hint">{{ passwordText.keepHint }}</div>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('비밀번호 확인')" :error="formError.accountPwConfirm" :required="passwordRequired">
              <el-input v-model="inputForm.accountPwConfirm" maxlength="20" type="password" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('핸드폰 번호')" :error="formError.tel" required>
              <el-input
                v-keep-number-caret
                :value="util.telFieldText(inputForm.tel)"
                maxlength="20"
                clearable
                show-word-limit
                @input="inputForm.tel = util.telDigits($event)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('이메일')" :error="formError.email" required>
              <el-input v-model="inputForm.email" maxlength="100" clearable show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('사용 가능 여부')" required>
              <combo :data="mainVue.code.useYn" :model="inputForm.useYn" @change="inputForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('만료 여부')" required>
              <combo
                :data="mainVue.code.nonExpired"
                :model="inputForm.nonExpired"
                @change="inputForm.nonExpired = $event"></combo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button icon="el-icon-check" :size="size" @click="save" :disabled="btn.saveDisabled">{{
          $t('저장')
        }}</el-button>
        <el-button icon="el-icon-close" :size="size" @click="dialogFormVisible = false">{{ $t('닫기') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mainVueMixin from '@/mixins/mainVueMixin'
import { PASSWORD_TEXT, blankPassword, passwordPatch } from '@/utils/accountPassword'
import { initData } from '@/utils/constants'
import { without } from '@/utils/without'

/**
 * 상세 응답 → 편집 폼. **푸시 토큰은 폼에 싣지 않는다.**
 *
 * 저장 본문은 폼 전체다(`passwordPatch` 가 비밀번호 두 칸만 덜어낸다). 그래서 상세가 준 키는 화면이
 * 고치지 않아도 그대로 되돌아 나간다 — 푸시 토큰은 단말이 쓰고 서버가 소유하는 값이고 상세는 **앞 8자만
 * 남긴 마스킹**으로 내려주므로, 되보내면 저장 본문에 마스킹된 문자열이 실린다. 서버가 갱신 때 보존하므로
 * 지금 덮어쓰이지는 않지만, **화면이 고치지 않는 값은 보내지 않는 것**이 계약이다.
 */
const READ_ONLY_FIELDS = ['pushToken']

function appUserForm(result) {
  return without(result, READ_ONLY_FIELDS)
}

export default {
  mixins: [mainVueMixin],

  data: function () {
    var data = initData()
    data.url = '/appUser'
    data.store = []

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()
    /** 비밀번호 축의 문구 — 판정과 같은 파일이 소유한다(`utils/accountPassword`) */
    data.passwordText = PASSWORD_TEXT

    return data
  },
  computed: {
    /** 비밀번호가 **필수인가** — 생성에서만 그렇다. 수정의 빈칸은 「그대로 둔다」는 뜻이다 */
    passwordRequired: function () {
      return 'I' === this.inputForm.statu
    },
  },
  created: function () {
    this.search()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  methods: {
    // 검색 조건 초기화
    initSearchForm: function () {
      return {
        accountId: '',
        accountNm: '',
        useYn: '',
        nonExpired: '',
      }
    },
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'U',
        title: '',
        accountId: '',
        accountNm: '',
        nickName: '',
        accountPw: '',
        accountPwConfirm: '',
        useYn: 'Y',
        nonExpired: 'Y',
        tel: '',
        email: '',
        store: { storeNm: '' },
      }
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        accountId: '',
        accountNm: '',
        accountPw: '',
        accountPwConfirm: '',
        tel: '',
        email: '',
        'store.storeCd': '',
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }

      this.selectData = val
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].accountId
      }
    },
    /** 수정 — 비밀번호 두 칸은 **언제나 빈칸**으로 연다([blankPassword], 보안 원장 ⑥) */
    up: function () {
      this.mainVue.$axios.get(
        this.url + '/' + this.selectData.accountId,
        function (result) {
          this.inputForm = Object.assign(appUserForm(result), blankPassword(), {
            statu: 'U',
            title: this.$t('앱 회원 수정'),
          })

          this.formError = this.initFormError()

          this.dialogFormVisible = true
          this.btn.saveDisabled = false
        }.bind(this),
        true
      )
    },
    // 조회
    search: function () {
      this.mainVue.$axios.search(
        this.url,
        this.searchForm,
        function (result) {
          this.tableData = result

          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true

          this.inputForm = this.initInputForm()
          this.formError = this.initFormError()
        }.bind(this),
        false
      )
    },
    // 삭제
    del: function () {
      this.mainVue
        .$confirm(this.$t('매장 회원 정보를 삭제 하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('삭제'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            this.mainVue.$axios.del(
              this.url + '/' + this.checkedData.join(','),
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this),
              true
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
          }.bind(this)
        )
    },
    /** 저장 — 비밀번호 축의 판정은 [passwordPatch] 한 곳이다(빈칸이면 두 키를 본문에서 뺀다) */
    save: function () {
      this.formError = this.initFormError()

      const patch = passwordPatch(this.inputForm)

      if (!patch.ok) {
        this.formError[patch.field] = this.$t(patch.message)

        return
      }

      if ('I' === this.inputForm.statu) {
        this.mainVue.$axios.add(
          this.url,
          patch.payload,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
            this.dialogFormVisible = false
            this.search()
          }.bind(this),
          true
        )
      } else {
        this.mainVue.$axios.up(
          this.url + '/' + this.inputForm.accountId,
          patch.payload,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
            this.dialogFormVisible = false
            this.search()
          }.bind(this),
          true
        )
      }
    },
    // 계정 아이디 체크
    chkAccountId: function () {
      this.mainVue.$axios.patchNonLoading(
        '/account/chk/' + this.inputForm.accountId,
        null,
        null,
        function (result) {
          if ('' == result) {
            this.formError.accountId = ''
            this.btn.saveDisabled = false
          } else {
            this.formError.accountId = this.$t('이미 사용중인 아이디입니다.')
            this.btn.saveDisabled = true
          }
        }.bind(this),
        false
      )
    },
  },
}
</script>
